import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-24 px-4 bg-petrol" data-id="element-182">
      <div className="max-w-3xl mx-auto" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-184">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-white" data-id="element-185">
            ¿Te suena conocido esto?
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed bg-night-card p-6 rounded-2xl border border-night-border" data-id="element-186">
            Domingo a las 11 de la noche. Mañana tenés clase de Química. Y
            todavía estás buscando cómo explicar la configuración electrónica, o
            cómo hacer que un problema de estequiometría tenga sentido para un
            alumno de secundaria que nunca vio el interior de un laboratorio.
            <br data-id="element-187" />
            <br data-id="element-188" />
            <span className="text-gold-light font-medium" data-id="element-189">
              No es tu culpa.
            </span>{' '}
            Es que llevás años peleando con libros de texto pensados para
            contextos que nada tienen que ver con la realidad de tus alumnos.
            Con laboratorios sin reactivos. Con currículos que cambian cada
            gobierno. Con materiales que después tenés que reescribir entero.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-190">
          <h3 className="text-xl font-bold text-white mb-8 text-center" data-id="element-191">
            El costo de no tener el material correcto:
          </h3>

          <ul className="space-y-4" data-id="element-192">
            {['Noches en vela buscando cómo traducir conceptos químicos densos a un lenguaje que tus alumnos puedan entender', 'Clases improvisadas porque no encontraste un material claro y listo para usar a tiempo', 'Alumnos desconectados que sienten que la química no tiene nada que ver con ellos ni con su vida', 'Silencios incómodos cuando un alumno pregunta la diferencia entre una reacción redox y una de doble desplazamiento y no tenés una respuesta clara a mano', 'Fines de semana perdidos armando planificaciones, actividades, laboratorios y evaluaciones desde cero una y otra vez', 'Prácticas de laboratorio que no podés hacer porque no tenés reactivos — y sin alternativas para reemplazarlas'].map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-night-card p-4 rounded-xl border border-danger-dark/30" data-id="element-193">
                <span className="text-danger mt-1" data-id="element-194">🔴</span>
                <span className="text-gray-300" data-id="element-195">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-night-border" data-id="element-196">
            <p className="text-2xl font-serif font-bold text-gold-gradient" data-id="element-197">
              Basta de regalar tu tiempo libre. Tu dedicación ya la tenés. Ahora
              te falta la herramienta.
            </p>
            <p className="text-xl mt-4 text-white" data-id="element-198">
              Planificá todo tu año hoy.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}